import { MenuItem2 } from "@blueprintjs/popover2";
import React from "react";

export const CreateItem = (query: string, active: boolean, handleClick: React.MouseEventHandler<HTMLElement>) => {
  return (
    <MenuItem2
      icon="add"
      text={`Create "${query}"`}
      active={active}
      onClick={handleClick}
      shouldDismissPopover={false}
      roleStructure="listoption"
    />
  );
};
